module.exports = __webpack_public_path__ + "static/img/49.4e9158e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/49.png
// module id = ifZR
// module chunks = 0